import * as Blockly from "blockly";

/*
 * Legacy Zero Robotics array blocks.
 *
 * These definitions are kept for loading old Blockly XML.
 */


    Blockly.Blocks["variables_array_get"] = {
        init: function () {
            this.appendDummyInput()
                .appendField("get")
                .appendField(
                    new Blockly.FieldVariable(null),
                    "ARRAY"
                );

            this.appendValueInput("INDEX")
                .setCheck("Number")
                .appendField("index");

            this.setOutput(true);
            this.setColour(330);
            this.setTooltip("Get an element from an array.");
            this.setHelpUrl("");
        }
    };



    Blockly.Blocks["variables_array_set"] = {
        init: function () {
            this.appendDummyInput()
                .appendField("set")
                .appendField(
                    new Blockly.FieldVariable(null),
                    "ARRAY"
                );

            this.appendValueInput("INDEX")
                .setCheck("Number")
                .appendField("index");

            this.appendValueInput("VALUE")
                .appendField("to");

            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(330);
            this.setTooltip("Set an element of an array.");
            this.setHelpUrl("");
        }
    };
